<template>
	<!--项目分享-->
    <el-main>
		<div class="box-card">
			<p class="share_project">
				{{ $t('PublishProject.ProjectSharing') }}
				<span>({{$t('PublishProject.LinkRemainsUnchanged')}})</span>
			</p>
			<div class="share-contont">
				<div class="fl_link">
					<p>{{$t('PublishProject.ShareLink')}}</p>
					<p class="link_line">
						<el-input id="copyurl" :disabled="true" v-model="share.address">
							<el-button slot="append" v-clipboard:copy="share.address" @click="copyUrl()">{{$t('PublishProject.Copy')}}</el-button>
						</el-input>
						<el-button style="margin-left: 10px;" size="medium" type="primary" @click="openwj()">{{$t('PublishProject.Open')}}</el-button>
					</p>
					<!-- <div class="fl_link_puare">
						<i class="icon iconfont iconfabu"></i>
						<span>发布到答题广场</span>
					</div> -->
				</div>
				<div class="qrCode" style="">
					<img :src="share.qrCode" :alt="$t('PublishProject.QRCode')" style="width: 100px; height: 100px" />
					<p style="font-size: 12px; width: 100px; text-align: center; color: #0080ff;cursor: pointer;" @click="qrCodeUpload(share.qrCode)">{{$t('PublishProject.DownloadQRCode')}}</p>
				</div>
			</div>
		</div>
		<div class="box-card">
			<p class="wx_share">{{$t('PublishProject.WeChatSharing')}}</p>
			<div class="wx_content">
				<div class="upload_explain">
					<div>
						<p
							style="
								font-family: MicrosoftYaHei;
								font-size: 14px;
								color: #333333;
							"
						>
							{{$t('PublishProject.UploadLogo')}}
						</p>
						<div style="display: flex; margin-top: 14px">
							<img :src="wxsharePicture" v-if="logo" :alt="$t('PublishProject.ShareLogo')" style="width: 40px; height: 40px" />
							<img :src="uploadSuces" v-if="logoSucc" :alt="$t('PublishProject.ShareLogo')" style="width: 40px; height: 40px" />
							<div style="margin-left: 20px">
								<el-upload
									class="avatar-uploader"
									:action="$config.service.uploadApi"
									:show-file-list="false"
									:on-success="handleSuccess"
									:before-upload="beforeAvatarUpload"
									:data="QiniuData"
									:on-remove="handleRemove"
									multiple
									:limit="1"
									v-if="btnUpload"
								>
									<el-button size="small" style="color: #0080ff">{{$t('PublishProject.ClickToUpload')}}</el-button>
								</el-upload>
								<button
									v-if="btnDel"
									@click="delImg()"
									class="btnDel"
									style="
										width: 88px;
										height: 34px;
										background: #fff;
										border-radius: 3px;
										border: 1px solid #ccc;
										color: #0080ff;
									"
								>
									{{$t('PublishProject.ClickToDelete')}}
								</button>
								<p
									style="
										font-family: MicrosoftYaHei;
										font-size: 12px;
										color: #666;
										margin-top: 17px;
									"
								>
									{{$t('PublishProject.ImageSupport')}}
								</p>
							</div>
						</div>
					</div>
					<div class="WXSharetitle">
						<p class="share_description">{{$t('PublishProject.ShareTitle')}}</p>
						<el-input v-model="wxshareTitle" :placeholder="$t('PublishProject.InputContent')" style="margin-top: 14px" @change="shareTitle"></el-input>
					</div>
					<div>
						<p class="share_description">{{$t('PublishProject.ShareDescriptionDescription')}}</p>
						<el-input
							type="textarea"
							:rows="6"
							resize="none"
							:placeholder="$t('PublishProject.InputContent')"
							v-model="wxshareContent"
							style="margin-top: 14px;"
							@change="shareDesc"
						></el-input>
					</div>
				</div>
				<div class="upload_preview">
					<div style="width:325px;">
						<p
							style="
								font-family: MicrosoftYaHei;
								color: #000;
								margin-top: 22px;
								font-size: 12px;
							"
						>
							{{$t('PublishProject.FriendSharingPreview')}}123
						</p>
						<div>
							<div class="send">
								<div class="arrow"></div>
								<div class="arrow_content_box" style="overflow: hidden">
									<div class="arrow_text_part">
										<p>{{ wxshareTitle }}</p>
										<span class="wjInfo_content" style="">{{ wxshareContent }}</span>
									</div>
									<img :src="wxsharePicture" v-if="logo" class="wjInfo_img" style="width: 40px; height: 40px" alt="" />
									<img :src="uploadSuces" v-if="logoSucc" class="wjInfo_img" style="width: 40px; height: 40px" alt="" />
								</div>
							</div>
							<div style="clear: both"></div>
							<img src="../../assets/pic_head.png" style="float: right; margin-top: -100px" alt="" />
						</div>
						<p style="font-size: 12px; margin-top: 49px; margin-bottom: 16px">{{$t('PublishProject.ShareMomentPreview')}}</p>
						<div
							style="
								width: 286px;
								height: 32px;
								display: flex;
								align-items: center;
							"
						>
							<img src="../../assets/pic_head.png" :alt="$t('PublishProject.WeChatAvatar')" />
							<span style="font-size: 14px; margin-left: 8px; overflow: hidden">{{$t('PublishProject.WeChatNickname')}}</span>
						</div>
						<div
							style="
								width: 286px;
								height: 58px;
								background: #ebebeb;overflow:hidden;
								margin-left: 35px;
								display: flex;
								align-items: center;
								background-color:#ffffff;
								border: 1px solid #d8d8d8;
								border-radius: 2px;
							"
						>
							<img :src="wxsharePicture" v-if="logo" style="margin-left: 5px; width: 40px; height: 40px" alt="" />
							<img :src="uploadSuces" v-if="logoSucc" style="margin-left: 5px; height: 40px; width: 40px" alt="" />
							<span style="font-size: 14px; margin-left: 10px; overflow: hidden">{{ wxshareTitle }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</el-main>
</template>

<script>
export default {
    name: 'ShareLink',
	data() {
		return {
			wid: sessionStorage.getItem('wid') || 0,
			wxshareTitle: '', // 微信分享标题
			wxshareContent: '', // 微信分享描述
			wxsharePicture: '', // 微信分享logo
			curWjInfo: {},
			share: {},
			logo: true,
			logoSucc: false,
			btnUpload: true,
			btnDel: false,
			uploadSuces: '',
			QiniuData: {
				biz: 'upDataWj',
				data: {}
			},
		};
	},
	mounted() {
		if (this.wid != 0) {
        	this.wjinfo()
		} else {
			this.$router.replace({
				path: '/my'
			});
		}
	},
	methods: {
		
		openwj() {
			let that = this;
			window.open(that.share.address);
		},
		copyUrl() {
			var copyurl = document.getElementById('copyurl');
			copyurl.select();
			document.execCommand('Copy');
			this.$message.success(this.$t('PublishProject.SuccessfullyCopied'));
		},
		qrCodeUpload(imgUrl) {
			this.down(imgUrl);
		},
		
		down(imgUrl) {
			// 保存二维码
			this.downloadIamge(imgUrl, this.$t('PublishProject.QRCode'));
		},
		
		downloadIamge(imgsrc, name) {
			// 下载图片地址和图片名
			var image = new Image();
			// 解决跨域 Canvas 污染问题
			image.setAttribute('crossOrigin', 'anonymous');
			image.onload = function() {
				var canvas = document.createElement('canvas');
				canvas.width = image.width;
				canvas.height = image.height;
				var context = canvas.getContext('2d');
				context.drawImage(image, 0, 0, image.width, image.height);
				var url = canvas.toDataURL('image/png'); // 得到图片的base64编码数据
				var a = document.createElement('a'); // 生成一个a元素
				var event = new MouseEvent('click'); // 创建一个单击事件
				a.download = name || 'photo'; // 设置图片名称
				a.href = url; // 将生成的URL设置为a.href属性
				a.dispatchEvent(event); // 触发a的单击事件
			};
			image.src = imgsrc;
		},
		//设置微信分享——描述
		shareDesc() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.setWXShareContent}`,
				data: {
					id: that.wid,
					WXShareContent: that.wxshareContent
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						console.group('设置微信分享描述');
						console.log('res', res);
						console.groupEnd();
					}
				}
			};
			that.$util.request(params);
		},
		//设置微信分享——标题
		shareTitle() {
			let that = this;
			let array = that.array;
			let params = {
				that: that,
				url: `${that.$config.service.setWXShareTitle}`,
				data: {
					id: that.wid,
					WXShareTitle: that.wxshareTitle
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						console.group('设置微信分享标题');
						console.log('res', res);
						console.groupEnd();
					}
				}
			};
			that.$util.request(params);
		},
		handleRemove() {
			this.uploadPicUrl = '';
		},
		beforeAvatarUpload(file) {
			this.QiniuData.data = file;
		},
		handleSuccess(res) {
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: that.$config.service.setWXSharePicture,
				data: {
					id: id,
					WXSharePicture: res.message
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.uploadSuces = res.resultBody;
						that.logo = false;
						that.logoSucc = true;
						that.btnUpload = false;
						that.btnDel = true;
						console.log('图片上传成功', res);
					}
				}
			};
			this.$util.request(params);
		},
		delImg() {
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: that.$config.service.delWXSharePicture,
				data: {
					id: id
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.logo = true;
						that.logoSucc = false;
						that.btnUpload = true;
						that.btnDel = false;
						console.log('图片删除成功', res);
					}
				}
			};
			this.$util.request(params);
		},
		wjinfo(){
			let that = this;
			let id = that.wid;
			console.log('id :>> ', id);
			let params = {
				that: this,
				url: `${this.$config.service.wjinfo}?id=${id}`,
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.curWjInfo = res.resultBody;
						console.log('that.curWjInfo :>> ', that.curWjInfo);
						that.wxshareTitle = that.$functions.html2string(res.resultBody.wxshareTitle);
						that.wxshareContent = that.$functions.html2string(res.resultBody.wxshareContent);
						// console.log('11111111', res.resultBody.wxsharePicture);
						if (res.resultBody.wxsharePicture == '') {
							that.wxsharePicture = that.$functions.isFoTon() ? require('../../assets/foton/foton40black.png') : require('../../assets/aixue.png');
						}
						if (res.resultBody.wxsharePicture == 'aixuelogo.png') {
							that.wxsharePicture = that.$functions.isFoTon() ? require('../../assets/foton/foton40black.png') : require('../../assets/aixue.png');
						} else {
							that.wxsharePicture = res.resultBody.wxsharePicture;
						}
						that.getUrl();
					}
				}
			};
			this.$util.request(params);
		},
		getUrl() {
			console.log('this.curWjInfo :>> ', this.curWjInfo);
			let that = this;
			let id = this.curWjInfo.id;
			let params = {
				that: that,
				url: `${that.$config.service.shareQuestionnaire}?id=${id}&urlPath=${window.location.origin}`,
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.share = res.resultBody;
						return;
					}
				}
			};
			that.$util.request(params);
		},
		publishwj() {
			let that = this;
			let title = this.$functions.html2string(this.$route.query.wjTitle);
			if (title.length > 20) {
				title = title.slice(0, 20) + '...';
			}
			let id = this.$route.query.id;
			this.$confirm(`【${title}】${this.$t('PublishProject.AndaPastiInginMenerbitkan')}?`, this.$t('main.tip'), {
				confirmButtonText: this.$t('main.ok'),
				cancelButtonText: this.$t('main.cancel'),
				type: 'warning'
			})
				.then(() => {
					that.loading = that.$loading({
						lock: true,
						text: that.$t('PublishProject.Penerbitan'),
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});

					let params = {
						that: that,
						url: `${that.$config.service.publishwj}?id=${id}&state=2`,
						data: {},
						method: 'POST',
						cb(res) {
							that.loading.close();
							that.loading = null;
							// if (res.code == 0) {
							that.$message({
								type: 'success',
								duration: 800,
								message: that.$t('PublishProject.BerjayaDiterbitkan')
							});
							sessionStorage.setItem('wstate', 2);
						}
					};
					that.$util.request(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: this.$t('PublishProject.TidakDiterbitkan')
					});
				});
		},
	},
};
</script>

<style lang="scss" scoped="scoped">
.box-card {
	margin: 0 auto;
}
/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: 1200px) {
	.box-card {
		/* width: calc(800px + 300px); */
		width: 800px;
	}
}
/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (max-width: 1200px) {
	.box-card {
		width: calc(800px + 300px);
	}
}
.share_project {
	font-family: MicrosoftYaHei;
	font-size: 16px;
	color: #333;
}
.share_project span {
	font-family: MicrosoftYaHei;
	font-size: 12px;
	color: #666;
	margin-left: 10px;
}
.share-contont {
	width: 800px;
	height: 190px;
	background: #fff;
	box-shadow: 2px 2px 5px #ccc;
	border-radius: 3px;
	margin-top: 17px;
	margin-bottom: 34px;
	display: flex;
	align-items: center;
}
.fl_link .fl_link_puare span {
	margin-left: 10px;
}
.fl_link .fl_link_puare i {
	font-size: 16px;
}
.fl_link .fl_link_puare {
	width: 150px;
	height: 36px;
	color: #666666;
	font-size: 12px;
	text-align: center;
	line-height: 36px;
	border: 1px solid #ccc;
	border-radius: 2px;
	background-color: #fff;
	margin-top: 20px;
}
.fl_link {
	width: 610px;
	height: 120px;
	border-right: 1px dashed #ccc;
	margin-left: 38px;
}
.link_line {
	margin-top: 11px;
}
/deep/ .link_line .el-input {
	width: 356px;
	height: 36px;
}
/deep/.link_line .el-input__inner {
	width: 280px;
	height: 36px;
}
/deep/.el-input .el-button {
	width: 76px !important;
	height: 36px;
	border: none;
	background: #409EFF;
	color: #fff;
	border-radius: 0px 3px 3px 0px;
}
.open_btn {
	width: 76px;
	height: 38px;
	border: none;
	background: #fff;
	border: 1px solid #0080ff;
	color: #0080ff;
	border-radius: 3px;
	margin-left: 10px;
}
.qrCode {
	width: 151px;
	height: 120px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	margin-left: 15px;
}
.wx_content {
	width: 800px;
	height: 439px;
	background: #fff;
	box-shadow: 2px 2px 5px #ccc;
	margin-top: 16px;
	margin-bottom: 34px;
	display: flex;
	justify-content: space-around;
	align-items: center;
}
.upload_explain {
	width: 356px;
	height: 399px;
}
.btnDel {
	width: 88px;
	height: 34px;
	background: #fff;
	border-radius: 3px;
	border: 1px solid #ccc;
	color: #0080ff;
}
.share_description {
	margin-top: 24px;
	font-size: 14px;
	font-family: MicrosoftYaHei;
	color: #333333;
}
.upload_preview {
	width: 376px;
	height: 399px;
	background: #f7f8fa;
	display: flex;
	justify-content: center;
}
.send {
	position: relative;
	width: 276px;
	height: 97px;
	background: #fff;
	border-radius: 5px; /* 圆角 */
	border: 1px solid #ccc;
	margin-top: 16px;
}
.send .arrow {
	width: 6px;
	height: 6px;
	background: #fff;
	z-index: 1;
	top: 11px;
	right: -4px;
	position: absolute;
	border-top: 1px solid #d8d8d8;
	border-right: 1px solid #d8d8d8;
	-webkit-transform: rotate(45deg);
	-ms-transform: rotate(45deg);
	transform: rotate(45deg);
}
.arrow_content_box {
	width: 260px;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 999;
	display: flex;
	justify-content: center;
}
.arrow_text_part {
	width: 193px;
	height: 70px;
	margin-top: 15px;
	margin-left: 15px;
}
.wjInfo_content {
	width: 193px;
	height: 32px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	font-size: 12px;
	margin-top: 10px;
}
.wjInfo_img {
	width: 40px;
	height: 40px;
	margin-top: 56px;
}
</style>
